import { render, staticRenderFns } from "./AssetRedemption.vue?vue&type=template&id=98bed71a&scoped=true"
import script from "./AssetRedemption.vue?vue&type=script&lang=js"
export * from "./AssetRedemption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bed71a",
  null
  
)

export default component.exports